import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { getHourDraftAsCard } from 'redux/selectors/hours.draft';
import type { IState } from 'redux/state';
import { Hour } from './Hour';

interface ExternalProps {
  sizeBasedOnDuration?: boolean;
}

const mapStateToProps = (state: IState) => ({
  hour: getHourDraftAsCard(state),
});

type StateProps = ReturnType<typeof mapStateToProps>;
type Props = ExternalProps & StateProps;

class HourDraftPreview extends PureComponent<Props> {
  render() {
    const { sizeBasedOnDuration, hour } = this.props;

    if (hour == null || !hour.day) {
      return null;
    }

    return (
      <Hour shouldAlwaysUpdate sizeBasedOnDuration={sizeBasedOnDuration} hour={hour} isEditing />
    );
  }
}

export default connect(mapStateToProps)(HourDraftPreview);
